export default __webpack_public_path__ + "static/media/O-070.a54205ad.png";